import React from 'react';
import Reveal from './Reveal';

/**
 * Responsive photo gallery with staggered scroll-reveal entrances and a subtle
 * hover zoom. Items flagged `wide` span two columns on desktop.
 *
 * items: [{ src, alt, caption, wide }]
 */
function FamilyGallery({ items }) {
  return (
    <div className="gallery">
      {items.map((item, i) => (
        <Reveal
          as="figure"
          key={item.src}
          variant="up"
          delay={(i % 3) * 90}
          className={`gallery__item ${item.wide ? 'gallery__item--wide' : ''}`}
        >
          <div className="gallery__frame">
            <img src={item.src} alt={item.alt} loading="lazy" />
          </div>
          {item.caption && (
            <figcaption className="gallery__caption">{item.caption}</figcaption>
          )}
        </Reveal>
      ))}
    </div>
  );
}

export default FamilyGallery;
